<template>
    <nav
        class="bcn-breadcrumbs"
        aria-label="Breadcrumb navigation"
    >
        <div v-html="`<script type='application/ld+json'>${JSON.stringify(structuredData)}</script>`" />
        <ul class="bcn-breadcrumbs__list">
            <li
                v-for="(item, index) in parents"
                :key="index"
                class="bcn-breadcrumbs__item"
            >
                <nuxt-link :to="`/${item.full_slug}`">
                    {{ item.name }}
                </nuxt-link>
            </li>

            <li class="bcn-breadcrumbs__item bcn-breadcrumbs__item--active">
                {{ current.name }}
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { ref } from 'vue'

const { parents, current, baseUrl } = defineProps(['parents', 'current', 'baseUrl'])

const structuredData = ref({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [],
})

parents.forEach((item, index) => {
    structuredData.value.itemListElement.push({
        '@type': 'ListItem',
        'position': index + 1,
        'item': {
            '@id': `${baseUrl}/${item.full_slug}`,
            'name': item.name,
        },
    })
})

structuredData.value.itemListElement.push({
    '@type': 'ListItem',
    'position': parents.length + 1,
    'item': {
        '@id': `${baseUrl}/${current.full_slug}`,
        'name': current.name,
    },
})
</script>

<style lang="scss">
@use 'bcn-breadcrumbs';
</style>
